import { useNavigate } from "react-router-dom";
import {
  hideBackButton,
  onBackButtonClick,
  showBackButton,
} from "@telegram-apps/sdk";
import { type PropsWithChildren, useEffect } from "react";

export function Page({
  children,
  back = true,
}: PropsWithChildren<{
  /**
   * True if it is allowed to go back from this page.
   */
  back?: boolean;
}>) {
  const navigate = useNavigate();

  useEffect(() => {
    if (back) {
      if (showBackButton.isAvailable()) {
        showBackButton();
        if (onBackButtonClick.isAvailable()) {
          return onBackButtonClick(() => {
            navigate(-1);
          });
        }
      }
    } else {
      if (hideBackButton.isAvailable()) {
        hideBackButton();
      }
    }
  }, [back, navigate]);

  return <>{children}</>;
}
